import restClient from "../restClient";

export const getCountries = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`countries?populate=*`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};
